import { type FC } from 'react'
import classNames from 'classnames'

const STATUS_CLASSES: Record<string, string> = {
  active: 'zocks-bg-color-success-background zocks-text-success-200',
  pending: 'zocks-bg-color-primary-light zocks-text-primary-contrast',
  expired: 'zocks-bg-color-danger-background zocks-text-danger-200',
  failedToDeliver: 'zocks-bg-color-primary-light zocks-text-primary-contrast',
  requested: 'zocks-bg-color-warning zocks-text-warning-text-200',
  deactivated: 'zocks-bg-color-gray-200 zocks-text-gray-700',
}

const STATUS_LABELS: Record<string, string> = {
  failedToDeliver: 'pending',
}

const FALLBACK_CLASSES = 'zocks-bg-color-gray-200 zocks-text-gray-700'

export interface TeamStatusChipProps {
  status: string
}

export const TeamStatusChip: FC<TeamStatusChipProps> = ({ status }) => (
  <span className={classNames('d-inline-flex align-items-center paragraph-small px-2 zocks-py-0.125 rounded-3', STATUS_CLASSES[status] ?? FALLBACK_CLASSES)}>
    {STATUS_LABELS[status] ?? status}
  </span>
)
